import { Theme } from '@shared/models/theme.model'
import { UploadedFile } from '@shared/models/uploaded-file'
import { BaseModel } from './base.model'
import { Currency } from './currency.model'

const defaultLogoSrc = '/assets/images/logo-light.svg'
const DEFAULT_TITLE = 'Linxio'
const DEFAULT_FAVICON = '/assets/favicon_default.ico'

export class PlatformSettings extends BaseModel {
  clientDefaultTheme: Theme
  createdAt: string
  currency: Currency
  domain: string
  emailName: string
  favicon: UploadedFile
  id: number
  logo: UploadedFile
  productName: string
  smsName: string
  supportEmail: string
  supportMsg: string
  supportPhone: string
  units: string
  updatedAt: string
  notificationEmail: string
  logoUrl?: string
  faviconUrl: string
  linkPlayMarket: string
  linkAppStore: string
  linkKnowledgeBase: string
  intercomId: string
  accountingEmail: string
  salesEmail: string
  hostApi: string
  hostApp: string
  hostTrack: string
  hostMessenger: string
  hostGoApi: string
  privacyPolicyLink: string
  termsOfUseLink: string

  constructor(src?: PlatformSettings) {
    super(src)
    this.productName = src.productName || DEFAULT_TITLE
  }

  setImages(fileUrl: string): void {
    this.logoUrl = this.logo ? `${fileUrl}${this.logo.path}${this.logo.name}` : defaultLogoSrc
    this.faviconUrl = this.favicon ? `${fileUrl}${this.favicon.path}${this.favicon.name}` : DEFAULT_FAVICON
  }
}
